import React, { Component } from 'react'
import ComingSoon from '../../../Upcomingpages/ComingSoon';
import { Trans, withTranslation } from 'react-i18next';

class StockIntake extends Component {
  render() {
    const { t } = this.props
    return (
      <div>
        <div id='eMed_table_name'>
          {t("StockIntake")}
        </div>
        <ComingSoon />
      </div>
    )
  }
}
export default withTranslation()(StockIntake)